<template>
  <b-modal
    id="modal-depublier"
    title-class="modal__title"
    title="Reprendre la saisie"
    @ok="desactivatePublishedStatus"
  >
    <p class="my-4">
      Pendant toute la durée de votre modification, votre parc restera publié sur GéoRisques avec les anciennes données.
      Une fois votre saisie terminée, pour rendre ces modifications visibles sur GéoRisques pensez à republier la fiche.
    </p>
    <template #footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button
        variant="info"
        title="Permettre la modification des informations du parc"
        @click="ok()"
      >
        Réactiver la saisie
      </b-button>
      <b-button
        variant="default"
        title="Ne pas réactiver la saisie"
        @click="cancel()"
      >
        Annuler
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import { BModal, BButton } from 'bootstrap-vue-next';
defineProps({
  desactivatePublishedStatus: {
    type: Function,
    required: true
  }
})
</script>
